import PageHandler from "./PageHandler";
import Pages from "Pages";

class OfflineLicensesInUseListPageHandler extends PageHandler {
  constructor() {
    super("offline-licenses-in-use-list", Pages.OfflineLicensesInUseListPage);
  }

  async fetch(parameters) {
    await this.rootStore.data.LicensesInUseStore.fetchByCustomerId(
      parameters.customerId
    );

    // Get loaded licenseInUse-records
    const licensesInUse = this.rootStore.data.LicensesInUseStore._data;
    if (licensesInUse && licensesInUse.length > 0)
      this.rootStore.data.UsersStore.fetchByCustomerId(parameters.customerId);
  }
}

export default OfflineLicensesInUseListPageHandler;



// WEBPACK FOOTER //
// ./src/Stores/UIStore/PageHandlers/OfflineLicensesInUseListPageHandler.js